import React from 'react'
import Layout from '../layout/main'

export default () => (
  <Layout>
    Gallery
  </Layout>
)